import React from 'react';
import PropTypes from 'prop-types';

const ErrorDisplay = ({ error, onRetry }) => {
  if (!error) return null;

  const message = error?.message || error?.response?.data?.message || 'An error occurred';

  return (
    <div className="alert alert-danger m-3" role="alert">
      <h4 className="alert-heading">Error</h4>
      <div>{message}</div>
      {onRetry && (
        <div className="mt-3">
          <button className="btn btn-danger btn-sm" onClick={onRetry}>
            Retry
          </button>
        </div>
      )}
    </div>
  );
};

ErrorDisplay.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string,
    response: PropTypes.object,
  }),
  onRetry: PropTypes.func,
};

export default ErrorDisplay;
